import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';

export interface PendingTemplate {
  name: string;
  category?: string;
  language?: string;
  components?: Array<{
    type: string;
    text?: string;
    buttons?: Array<{ type: string; text: string; url?: string }>;
  }>;
}

export interface PendingFlow {
  name?: string;
  description?: string;
  nodes?: any[];
  edges?: any[];
  created_at?: string;
  trigger_type?: string;
  triggerType?: string;
  trigger_keywords?: string[];
  trigger_config?: {
    keywords?: string[];
  };
  trigger?: {
    type?: string;
    keywords?: string[];
  };
}

interface PendingOnboardingAssets {
  pending_templates: PendingTemplate[];
  pending_flow: PendingFlow | null;
  activated_business_account_id?: string | null;
  activated_at?: string | null;
}

export function usePendingOnboardingAssets(opts: { enabled?: boolean } = {}) {
  return useQuery<PendingOnboardingAssets>({
    queryKey: ['onboarding-pending-assets'],
    queryFn: async () => {
      // Only the four fields below - the full onboarding record is ~20 KB and
      // this runs on every protected page (FeatureRoute / RoleRoute).
      const res = await apiClient.get('/onboarding/qa', { params: { fields: 'pending' } });
      const data = res.data?.data || res.data || {};
      return {
        pending_templates: Array.isArray(data.pending_templates) ? data.pending_templates : [],
        pending_flow: data.pending_flow ?? null,
        activated_business_account_id: data.activated_business_account_id ?? null,
        activated_at: data.activated_at ?? null,
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: opts.enabled ?? true,
  });
}
